import React, { useEffect } from 'react';
import useLoadAdminFromSession from './useLoadAdminFromSession';
import { initNotificationSound } from './shared/utils/notificationSound';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import './styles/global-improvements.css';
import { TitleProvider } from './context/TitleContext';
import Footer from './shared/components/Footer';
import Home from './shared/components/Home/Home';
import Layout from './shared/components/Layout';
import DoctorDashboard from './features/doctor/pages/DoctorDashboard';
import DoctorProfile from './features/doctor/pages/DoctorProfile';
import DoctorProfileEdit from './features/doctor/pages/DoctorProfileEdit';
import DoctorInvitations from './features/doctor/pages/DoctorInvitations';
import DoctorClinics from './features/doctor/pages/DoctorClinics';
import DoctorAppointments from './features/doctor/pages/DoctorAppointments';
import DoctorWorkDays from './features/doctor/pages/DoctorWorkDays';
import DoctorMyReservations from './features/doctor/pages/DoctorMyReservations';
import DoctorMakeWorkDay from './features/doctor/pages/DoctorMakeWorkDay';
import DoctorDaySlots from './features/doctor/pages/DoctorDaySlots';
import DoctorClinicWorkingDays from './features/doctor/pages/DoctorClinicWorkingDays';
import DoctorEmptyDays from './features/doctor/pages/DoctorEmptyDays';
import DoctorConsultationPrice from './features/doctor/pages/DoctorConsultationPrice';
import ClinicDashboard from './features/clinic/pages/ClinicDashboard';
import ClinicProfileView from './features/clinic/pages/ClinicProfileView';
import ClinicProfileEdit from './features/clinic/pages/ClinicProfileEdit';
import ClinicDoctors from './features/clinic/pages/ClinicDoctors';
import ClinicBranches from './features/clinic/pages/ClinicBranches';
import LoginPage from './features/auth/pages/Login';
import AdminLoginPage from './features/auth/pages/AdminLogin';
import AdminVerify2FA from './features/auth/pages/AdminVerify2FA';
import StoreRegister from './features/auth/pages/StoreRegister';
import StoreOTP from './features/auth/pages/StoreOTP';
import StoreForgotPassword from './features/auth/pages/StoreForgotPassword';
import StoreChangePassword from './features/auth/pages/StoreChangePassword';
import StoreActivate from './features/auth/pages/StoreActivate';
import Profile from './features/store/pages/Profile';
import Roles from './features/admin/pages/Roles';
import AddRole from './features/admin/pages/AddRole';
import EditRole from './features/admin/pages/EditRole';
import StoreBranches from './features/store/branches/StoreBranches';
import AddBranch from './features/store/branches/AddBranch';
import EditBranch from './features/store/branches/EditBranch';
import BranchDetails from './features/store/branches/BranchDetails';
import BranchOrders from './features/store/branches/BranchOrders';
import BranchOrderDetails from './features/store/branches/BranchOrderDetails';
// removed realtime store orders and dashboard imports
import PharmacySubCategory from './features/store/pharmacy/PharmacySubCategory';
import PharmacyAddSubCategory from './features/store/pharmacy/PharmacyAddSubCategory';
import PharmacySubCategoriesEdit from './features/store/pharmacy/PharmacySubCategoriesEdit';
import PharmacyBranchRequests from './features/store/pharmacy/PharmacyBranchRequests';
import PharmacyBranchRequestDetails from './features/store/pharmacy/PharmacyBranchRequestDetails';
import PharmacyBranchRequestsNew from './features/store/pharmacy/PharmacyBranchRequestsNew';
import PharmacyBranchRequestDetailsNew from './features/store/pharmacy/PharmacyBranchRequestDetailsNew';
import PharmacyBranchRequestReply from './features/store/pharmacy/PharmacyBranchRequestReply';
import PharmacyBranchOrders from './features/store/pharmacy/PharmacyBranchOrders';
import PharmacyBranchOrderDetails from './features/store/pharmacy/PharmacyBranchOrderDetails';
import PharmacyProducts from './features/store/pharmacy/PharmacyProducts';
import PharmacyAddProduct from './features/store/pharmacy/PharmacyAddProduct';
import PharmacyProductDetails from './features/store/pharmacy/PharmacyProductDetails';
import PharmacyEditProduct from './features/store/pharmacy/PharmacyEditProduct';
// import SubCategories from './pages/pharmacy/SubCategories';
// import ProductDetails from './pages/pharmacy/ProductDetails';
import Admins from './features/admin/pages/Admins';
import AddAdmin from './features/admin/pages/AddAdmin';
import EditAdmin from './features/admin/pages/EditAdmin';
import PrivateRoute from './shared/components/PrivateRoute';
import AdminNotifications from './features/admin/notifications/AdminNotifications';
import Products from './features/store/products/Products';
import AddProduct from './features/store/products/AddProduct';
import EditProduct from './features/store/products/EditProduct';
import ViewProduct from './features/store/products/ViewProduct';
import AdminBanners from './features/admin/banners/AdminBanners';
import AdminAddBanner from './features/admin/banners/AdminAddBanner';
import AdminEditBanner from './features/admin/banners/AdminEditBanner';
import AdminClients from './features/admin/clients/AdminClients';
import AdminClientDetails from './features/admin/clients/AdminClientDetails';
import AdminStores from './features/admin/stores/AdminStores';
import AdminStoreDetails from './features/admin/stores/AdminStoreDetails';
import AdminStoreBranches from './features/admin/stores/AdminStoreBranches';
import AdminStoreBranchDetails from './features/admin/stores/AdminStoreBranchDetails';
import AdminPharmacies from './features/admin/pharmacies/AdminPharmacies';
import AdminPharmacyDetails from './features/admin/pharmacies/AdminPharmacyDetails';
import AdminPharmacyBranches from './features/admin/pharmacies/AdminPharmacyBranches';
import AdminPharmacyBranchDetails from './features/admin/pharmacies/AdminPharmacyBranchDetails';
import AdminPharmacySettings from './features/admin/pharmacies/AdminPharmacySettings';
import AdminClinics from './features/admin/clinics/AdminClinics';
import AdminClinicDoctors from './features/admin/clinics/AdminClinicDoctors';
import AddClinic from './features/admin/clinics/AddClinic';
import AdminDoctors from './features/admin/doctors/AdminDoctors';
import AdminUnits from './features/admin/units/AdminUnits';
import DoctorReservations from './features/admin/doctors/DoctorReservations';
import AdminSupport from './features/admin/support/AdminSupport';
import AdminSupportAdd from './features/admin/support/AdminSupportAdd';
import AdminSupportDetails from './features/admin/support/AdminSupportDetails';
import AdminSupportEdit from './features/admin/support/AdminSupportEdit';
import AdminSubSubCategories from './features/admin/categories/AdminSubSubCategories';
import AdminSubSubCategoryAdd from './features/admin/categories/AdminSubSubCategoryAdd';
import AdminSubSubCategoryEdit from './features/admin/categories/AdminSubSubCategoryEdit';
import AdminPromoCodes from './features/admin/promocodes/AdminPromoCodes';
import AdminAddPromoCode from './features/admin/promocodes/AdminAddPromoCode';
import AdminEditPromoCode from './features/admin/promocodes/AdminEditPromoCode';
import AdminPromoCodeDetails from './features/admin/promocodes/AdminPromoCodeDetails';
import StorePromoCodes from './features/store/promocodes/StorePromoCodes';
import StoreAddPromoCode from './features/store/promocodes/StoreAddPromoCode';
import StoreEditPromoCode from './features/store/promocodes/StoreEditPromoCode';
import StorePromoCodeDetails from './features/store/promocodes/StorePromoCodeDetails';
import PharmacyPromoCodes from './features/pharmacy/promocodes/PharmacyPromoCodes';
import PharmacyAddPromoCode from './features/pharmacy/promocodes/PharmacyAddPromoCode';
import PharmacyEditPromoCode from './features/pharmacy/promocodes/PharmacyEditPromoCode';
import PharmacyPromoCodeDetails from './features/pharmacy/promocodes/PharmacyPromoCodeDetails';
import AdminProducts from './features/admin/products/AdminProducts';
import AdminProductDetails from './features/admin/products/AdminProductDetails';
import AdminDeliveries from './features/admin/deliveries/AdminDeliveries';
import AdminDeliveryDetails from './features/admin/deliveries/AdminDeliveryDetails';
import AdminPharmacyRequests from './features/admin/pharmacy-requests/AdminPharmacyRequests';
import AdminPharmacyRequestDetails from './features/admin/pharmacy-requests/AdminPharmacyRequestDetails';
import AdminOrders from './features/admin/orders/AdminOrders';
import AdminOrderDetails from './features/admin/orders/AdminOrderDetails';
import AdminPermissions from './features/admin/permissions/AdminPermissions';
import AddRolePermission from './features/admin/permissions/AddRole';
import EditRolePermission from './features/admin/permissions/EditRole';
import AdminCategories from './features/admin/categories/AdminCategories';
import AdminEditCategory from './features/admin/categories/AdminEditCategory';
import AdminSubCategories from './features/admin/categories/AdminSubCategories';
import AdminAddSubCategory from './features/admin/categories/AdminAddSubCategory';
import AdminEditSubCategory from './features/admin/categories/AdminEditSubCategory';
import AdminBranchComplaints from './features/admin/complaints/AdminBranchComplaints';
import AdminAppSettings from './features/admin/settings/AdminAppSettings';
import AdminTechnicians from './features/admin/technicians/AdminTechnicians';

// Locations Imports
import Countries from './features/admin/locations/Countries';
import AddCountry from './features/admin/locations/AddCountry';
import EditCountry from './features/admin/locations/EditCountry';
import CountryDetails from './features/admin/locations/CountryDetails';
import Governments from './features/admin/locations/Governments';
import AddGovernment from './features/admin/locations/AddGovernment';
import EditGovernment from './features/admin/locations/EditGovernment';
import GovernmentDetails from './features/admin/locations/GovernmentDetails';
import Centers from './features/admin/locations/Centers';
import AddCenter from './features/admin/locations/AddCenter';
import EditCenter from './features/admin/locations/EditCenter';
import CenterDetails from './features/admin/locations/CenterDetails';

// CSS مخصص للتأكد من ظهور التوست
const toastStyles = `
  .Toastify__toast-container {
    z-index: 9999999 !important;
    position: fixed !important;
  }
  .Toastify__toast {
    direction: rtl !important;
    text-align: right !important;
    font-family: 'Montserrat', 'Arial', sans-serif !important;
    font-size: 14px !important;
    color: white !important;
  }
  .Toastify__toast--success {
    background: #28a745 !important;
  }
  .Toastify__toast--error {
    background: #dc3545 !important;
  }
  .Toastify__toast--warning {
    background: #ffc107 !important;
  }
  .Toastify__toast--info {
    background: #17a2b8 !important;
  }
  
  /* Toast icons - force white color */
  .Toastify__toast-icon {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--success .Toastify__toast-icon {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--success .Toastify__toast-icon svg {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--error .Toastify__toast-icon {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--error .Toastify__toast-icon svg {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--warning .Toastify__toast-icon {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--warning .Toastify__toast-icon svg {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--info .Toastify__toast-icon {
    color: white !important;
    fill: white !important;
  }
  
  .Toastify__toast--info .Toastify__toast-icon svg {
    color: white !important;
    fill: white !important;
  }
  
  /* Force all toast content to be white */
  .Toastify__toast * {
    color: white !important;
  }
  
  .Toastify__toast svg {
    color: white !important;
    fill: white !important;
  }
`;

// إضافة الـ CSS إلى الصفحة
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = toastStyles;
  document.head.appendChild(style);
}

function App() {
  useLoadAdminFromSession();

  // تفعيل صوت الإشعارات: نفك قفل الصوت عند أول تفاعل من المستخدم (مطلوب على iOS).
  useEffect(() => {
    initNotificationSound();
  }, []);

  return (
    <>
      <TitleProvider>
        <Router>
          <Routes>
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Home />} />
              <Route
                path="/admin-units"
                element={
                  <PrivateRoute>
                    <AdminUnits />
                  </PrivateRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/roles"
                element={
                  <PrivateRoute>
                    <Roles />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admins"
                element={
                  <PrivateRoute>
                    <Admins />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-admin"
                element={
                  <PrivateRoute>
                    <AddAdmin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-admin/:id"
                element={
                  <PrivateRoute>
                    <EditAdmin />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-role"
                element={
                  <PrivateRoute>
                    <AddRole />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-role/:id"
                element={
                  <PrivateRoute>
                    <EditRole />
                  </PrivateRoute>
                }
              />

         

           


              {/* Store Branches Routes */}
              <Route
                path="/store-branches"
                element={
                  <PrivateRoute>
                    <StoreBranches />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store-branches/add"
                element={
                  <PrivateRoute>
                    <AddBranch />
                  </PrivateRoute>
                }
              />
              {/* Products Routes */}
              <Route
                path="/view-products"
                element={
                  <PrivateRoute>
                    <Products />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-product"
                element={
                  <PrivateRoute>
                    <AddProduct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/view-product/:id"
                element={
                  <PrivateRoute>
                    <ViewProduct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/edit-product/:id"
                element={
                  <PrivateRoute>
                    <EditProduct />
                  </PrivateRoute>
                }
              />
              {/* branches routes */}
              <Route
                path="/store-branches/edit"
                element={
                  <PrivateRoute>
                    <EditBranch />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store-branches/:id"
                element={
                  <PrivateRoute>
                    <BranchDetails />
                  </PrivateRoute>
                }
              />

              {/* Store Orders Routes */}
              <Route
                path="/store/orders"
                element={
                  <PrivateRoute>
                    <BranchOrders />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store/orders/:id"
                element={
                  <PrivateRoute>
                    <BranchOrderDetails />
                  </PrivateRoute>
                }
              />

              {/* Branch Orders Routes */}
              <Route
                path="/main-branch/orders"
                element={
                  <PrivateRoute>
                    <BranchOrders />
                  </PrivateRoute>
                }
              />
              <Route
                path="/main-branch/orders/:id"
                element={
                  <PrivateRoute>
                    <BranchOrderDetails />
                  </PrivateRoute>
                }
              />
              
              {/* Pharmacy Routes */}
              <Route
                path="/pharmacy-subcategories"
                element={
                  <PrivateRoute>
                    <PharmacySubCategory />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-subcategories/add"
                element={
                  <PrivateRoute>
                    <PharmacyAddSubCategory />
                  </PrivateRoute>
                }
              />
        <Route
          path="/pharmacy-subcategories/edit/:id"
          element={
            <PrivateRoute>
              <PharmacySubCategoriesEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/pharmacy-branch-requests"
          element={
            <PrivateRoute>
              <PharmacyBranchRequests />
            </PrivateRoute>
          }
        />
        <Route
          path="/pharmacy-branch-requests/:id"
          element={
            <PrivateRoute>
              <PharmacyBranchRequestDetails />
            </PrivateRoute>
          }
        />
              <Route
                path="/pharmacy-products"
                element={
                  <PrivateRoute>
                    <PharmacyProducts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-products/add"
                element={
                  <PrivateRoute>
                    <PharmacyAddProduct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-products/:id"
                element={
                  <PrivateRoute>
                    <PharmacyProductDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-products/edit/:id"
                element={
                  <PrivateRoute>
                    <PharmacyEditProduct />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-branch-requests-new"
                element={
                  <PrivateRoute>
                    <PharmacyBranchRequestsNew />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-branch-requests-new/:id"
                element={
                  <PrivateRoute>
                    <PharmacyBranchRequestDetailsNew />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-branch-requests-new/:id/reply"
                element={
                  <PrivateRoute>
                    <PharmacyBranchRequestReply />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-branch-orders"
                element={
                  <PrivateRoute>
                    <PharmacyBranchOrders />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-branch-orders/:id"
                element={
                  <PrivateRoute>
                    <PharmacyBranchOrderDetails />
                  </PrivateRoute>
                }
              />

              {/* Admin Routes */}

                {/* Admin Notifications Route */}
                <Route
                  path="/admin/dashboard/notifications/send"
                  element={
                    <PrivateRoute>
                      <AdminNotifications />
                    </PrivateRoute>
                  }
                />
              <Route
                path="/admin-banners"
                element={
                  <PrivateRoute>
                    <AdminBanners />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-add-banner"
                element={
                  <PrivateRoute>
                    <AdminAddBanner />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-edit-banner/:id"
                element={
                  <PrivateRoute>
                    <AdminEditBanner />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-clients"
                element={
                  <PrivateRoute>
                    <AdminClients />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-clients/:id"
                element={
                  <PrivateRoute>
                    <AdminClientDetails />
                  </PrivateRoute>
                }
              />
              
              {/* Locations Routes */}
              <Route path="/admin-locations/countries" element={<PrivateRoute><Countries /></PrivateRoute>} />
              <Route path="/admin-locations/countries/add" element={<PrivateRoute><AddCountry /></PrivateRoute>} />
              <Route path="/admin-locations/countries/:id/edit" element={<PrivateRoute><EditCountry /></PrivateRoute>} />
              <Route path="/admin-locations/countries/:id" element={<PrivateRoute><CountryDetails /></PrivateRoute>} />

              <Route path="/admin-locations/governments" element={<PrivateRoute><Governments /></PrivateRoute>} />
              <Route path="/admin-locations/governments/add" element={<PrivateRoute><AddGovernment /></PrivateRoute>} />
              <Route path="/admin-locations/governments/:id/edit" element={<PrivateRoute><EditGovernment /></PrivateRoute>} />
              <Route path="/admin-locations/governments/:id" element={<PrivateRoute><GovernmentDetails /></PrivateRoute>} />

              <Route path="/admin-locations/centers" element={<PrivateRoute><Centers /></PrivateRoute>} />
              <Route path="/admin-locations/centers/add" element={<PrivateRoute><AddCenter /></PrivateRoute>} />
              <Route path="/admin-locations/centers/:id/edit" element={<PrivateRoute><EditCenter /></PrivateRoute>} />
              <Route path="/admin-locations/centers/:id" element={<PrivateRoute><CenterDetails /></PrivateRoute>} />

              <Route
                path="/admin-stores"
                element={
                  <PrivateRoute>
                    <AdminStores />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-stores/:id"
                element={
                  <PrivateRoute>
                    <AdminStoreDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-stores/:id/branches"
                element={
                  <PrivateRoute>
                    <AdminStoreBranches />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-stores/:id/branches/:branchId"
                element={
                  <PrivateRoute>
                    <AdminStoreBranchDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacies"
                element={
                  <PrivateRoute>
                    <AdminPharmacies />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacies/:pharmacyId"
                element={
                  <PrivateRoute>
                    <AdminPharmacyDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacies/:pharmacyId/branches"
                element={
                  <PrivateRoute>
                    <AdminPharmacyBranches />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacies/:pharmacyId/branches/:branchId"
                element={
                  <PrivateRoute>
                    <AdminPharmacyBranchDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacy-settings"
                element={
                  <PrivateRoute>
                    <AdminPharmacySettings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-clinics"
                element={
                  <PrivateRoute>
                    <AdminClinics />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-clinics/add"
                element={
                  <PrivateRoute>
                    <AddClinic />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-clinics/doctors/:clinicId"
                element={
                  <PrivateRoute>
                    <AdminClinicDoctors />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-doctors"
                element={
                  <PrivateRoute>
                    <AdminDoctors />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-technicians"
                element={
                  <PrivateRoute>
                    <AdminTechnicians />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-support"
                element={
                  <PrivateRoute>
                    <AdminSupport />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/branch-complaints"
                element={
                  <PrivateRoute>
                    <AdminBranchComplaints />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/settings"
                element={
                  <PrivateRoute>
                    <AdminAppSettings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-support/add"
                element={
                  <PrivateRoute>
                    <AdminSupportAdd />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-support/:questionId"
                element={
                  <PrivateRoute>
                    <AdminSupportDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-support/edit/:questionId"
                element={
                  <PrivateRoute>
                    <AdminSupportEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-products"
                element={
                  <PrivateRoute>
                    <AdminProducts />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-products/:productId"
                element={
                  <PrivateRoute>
                    <AdminProductDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-deliveries"
                element={
                  <PrivateRoute>
                    <AdminDeliveries />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-deliveries/:deliveryId"
                element={
                  <PrivateRoute>
                    <AdminDeliveryDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacy-requests"
                element={
                  <PrivateRoute>
                    <AdminPharmacyRequests />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-pharmacy-requests/:requestId"
                element={
                  <PrivateRoute>
                    <AdminPharmacyRequestDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/orders"
                element={
                  <PrivateRoute>
                    <AdminOrders />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin/orders/:orderId"
                element={
                  <PrivateRoute>
                    <AdminOrderDetails />
                  </PrivateRoute>
                }
              />
              {/* Admin Promo Codes Routes */}
              <Route
                path="/admin-promo-codes"
                element={
                  <PrivateRoute>
                    <AdminPromoCodes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-promo-codes/add"
                element={
                  <PrivateRoute>
                    <AdminAddPromoCode />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-promo-codes/:id"
                element={
                  <PrivateRoute>
                    <AdminPromoCodeDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-promo-codes/:id/edit"
                element={
                  <PrivateRoute>
                    <AdminEditPromoCode />
                  </PrivateRoute>
                }
              />
              
              {/* Store Promo Codes Routes */}
              <Route
                path="/store-promo-codes"
                element={
                  <PrivateRoute>
                    <StorePromoCodes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store-promo-codes/add"
                element={
                  <PrivateRoute>
                    <StoreAddPromoCode />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store-promo-codes/:id"
                element={
                  <PrivateRoute>
                    <StorePromoCodeDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/store-promo-codes/:id/edit"
                element={
                  <PrivateRoute>
                    <StoreEditPromoCode />
                  </PrivateRoute>
                }
              />
              
              {/* Pharmacy Promo Codes Routes */}
              <Route
                path="/pharmacy-promo-codes"
                element={
                  <PrivateRoute>
                    <PharmacyPromoCodes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-promo-codes/add"
                element={
                  <PrivateRoute>
                    <PharmacyAddPromoCode />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-promo-codes/:id"
                element={
                  <PrivateRoute>
                    <PharmacyPromoCodeDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pharmacy-promo-codes/:id/edit"
                element={
                  <PrivateRoute>
                    <PharmacyEditPromoCode />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-permissions"
                element={
                  <PrivateRoute>
                    <AdminPermissions />
                  </PrivateRoute>
                }
              />
              <Route
                path="/add-role"
                element={
                  <PrivateRoute>
                    <AddRolePermission />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories"
                element={
                  <PrivateRoute>
                    <AdminCategories />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:categoryId/edit"
                element={
                  <PrivateRoute>
                    <AdminEditCategory />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:categoryId/sub-categories"
                element={
                  <PrivateRoute>
                    <AdminSubCategories />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:subCategoryId/sub-sub-categories"
                element={
                  <PrivateRoute>
                    <AdminSubSubCategories />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:subCategoryId/sub-sub-categories/add"
                element={
                  <PrivateRoute>
                    <AdminSubSubCategoryAdd />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:subCategoryId/sub-sub-categories/edit/:subSubCategoryId"
                element={
                  <PrivateRoute>
                    <AdminSubSubCategoryEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:categoryId/sub-categories/add"
                element={
                  <PrivateRoute>
                    <AdminAddSubCategory />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin-categories/:categoryId/sub-categories/:subCategoryId/edit"
                element={
                  <PrivateRoute>
                    <AdminEditSubCategory />
                  </PrivateRoute>
                }
              />

              {/* Doctor Routes */}
              <Route
                path="/doctor/profile"
                element={
                  <PrivateRoute>
                    <DoctorProfile />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/profile/edit"
                element={
                  <PrivateRoute>
                    <DoctorProfileEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/invitations"
                element={
                  <PrivateRoute>
                    <DoctorInvitations />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/clinics"
                element={
                  <PrivateRoute>
                    <DoctorClinics />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/make-work-day"
                element={
                  <PrivateRoute>
                    <DoctorMakeWorkDay />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/day-slots"
                element={
                  <PrivateRoute>
                    <DoctorDaySlots />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/reservations"
                element={
                  <PrivateRoute>
                    <DoctorMyReservations />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/clinic-working-days"
                element={
                  <PrivateRoute>
                    <DoctorClinicWorkingDays />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/appointments/:clinicId"
                element={
                  <PrivateRoute>
                    <DoctorAppointments />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/work-days/:clinicId"
                element={
                  <PrivateRoute>
                    <DoctorWorkDays />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/empty-days/:clinicId"
                element={
                  <PrivateRoute>
                    <DoctorEmptyDays />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctor/consultation-price"
                element={
                  <PrivateRoute>
                    <DoctorConsultationPrice />
                  </PrivateRoute>
                }
              />
              <Route
                path="/doctors/doctor_reservations/:doctorId"
                element={
                  <PrivateRoute>
                    <DoctorReservations />
                  </PrivateRoute>
                }
              />

              {/* Clinic Routes */}
              <Route
                path="/clinic-dashboard"
                element={
                  <PrivateRoute>
                    <Layout>
                      <ClinicDashboard />
                    </Layout>
                  </PrivateRoute>
                }
              />
              <Route
                path="/clinic/profile"
                element={
                  <PrivateRoute>
                    <ClinicProfileView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clinic/profile/edit"
                element={
                  <PrivateRoute>
                    <ClinicProfileEdit />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clinic/branches"
                element={
                  <PrivateRoute>
                    <ClinicBranches />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clinic/doctors"
                element={
                  <PrivateRoute>
                    <ClinicDoctors />
                  </PrivateRoute>
                }
              />
              
            </Route>
            <Route path="login" element={<LoginPage />} />
            <Route path="admin-login" element={<AdminLoginPage />} />
            <Route path="admin/verify-2fa" element={<AdminVerify2FA />} />
            <Route path="store-register" element={<StoreRegister />} />
            <Route path="store-otp" element={<StoreOTP />} />
            <Route path="store-forgot-password" element={<StoreForgotPassword />} />
            <Route path="store-change-password" element={<StoreChangePassword />} />
            <Route path="store-activate" element={<StoreActivate />} />
            <Route 
              path="doctor-dashboard" 
              element={
                <PrivateRoute>
                  <Layout>
                    <DoctorDashboard />
                  </Layout>
                </PrivateRoute>
              } 
            />
            </Routes>
          <Footer />
        </Router>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={true}
          rtl={true}
          pauseOnFocusLoss={false}
          draggable={true}
          pauseOnHover={true}
          containerId="main-toast-container"
          enableMultiContainer={false}
        />
        
      </TitleProvider>
    </>
  );
}

export default App;
